import { Component } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
    selector: 'lib-gung-settings-navigation-view',
    templateUrl: './gung-settings-navigation-view.component.html',
    styleUrl: './gung-settings-navigation-view.component.scss',
    standalone: false
})
export class GungSettingsNavigationViewComponent extends GungSettingsBaseViewComponent {}
